import { createSelector, createReducer } from '@reduxjs/toolkit';
import { CONTENTTYPE_INCLUDE } from '../../constants/api';
import {
  getAllCommentsForHearingSuccess,
  getAllHearingsSuccess,
  getHearingSuccess,
  getPaginatedCommentsForHearingSuccess,
  getPaginatedHearingsSuccess,
} from '../actions/api';
import { getAttr } from '../helpers/apiHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';

import {
  getIncludedData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------

// ContentType is included in the following endpoints
//  - GET /hearing/{hearingId}/comment
//  - GET /hearing
//  - GET /hearing/{hearingId}

// -------- Reducer --------
const contentTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder
      .addCase(getAllHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contentTypes = data.filter(
          (include) => include.type === CONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', contentTypes);
      })
      .addCase(getHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contentTypes = data.filter(
          (include) => include.type === CONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', contentTypes);
      })
      .addCase(getAllCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contentTypes = data.filter(
          (include) => include.type === CONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', contentTypes);
      })
      .addCase(getPaginatedCommentsForHearingSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contentTypes = data.filter(
          (include) => include.type === CONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', contentTypes);
      })
      .addCase(getPaginatedHearingsSuccess, (state, action) => {
        const data = getIncludedData(action);
        const contentTypes = data.filter(
          (include) => include.type === CONTENTTYPE_INCLUDE,
        );
        return updateDtoList(state, 'all', contentTypes);
      });
  },
);

// -------- Selectors --------
const selectGetAllcontentTypes = (state) =>
  selectAllFromApiState(state, 'contentType');
const allContentTypesSelector = createSelector(
  selectGetAllcontentTypes,
  (contentTypes) => contentTypes,
);
const contentTypeByTypeSelector = (type) =>
  createSelector(selectGetAllcontentTypes, (contentTypes) =>
    contentTypes.find(
      (contentType) => getAttr(contentType, 'contentType') === type,
    ),
  );

// -------- Exporting --------
export { allContentTypesSelector, contentTypeByTypeSelector };
export default contentTypeReducer;
